import { FC } from 'react';
import { SettingsPaymentMethods } from '~/components/settings/payment-methods';
import { SettingsLayout } from './layout';

export const PaymentMethods: FC = () => {
  /**
   * DOM
   */
  return (
    <SettingsLayout header="Bank accounts">
      <SettingsPaymentMethods />
    </SettingsLayout>
  );
};
